import { Component, OnInit } from "@angular/core";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { forkJoin } from "rxjs/observable/forkJoin";
import { FinancialReportsService } from "../services/financial-reports/financial-reports.service";
import { ProjectsService } from "../services/projects/projects.service";
import { ErrorHandlerService } from "../services/shared/error-handler.service";
import { UserServiceService } from "../services/user-service/user-service.service";
import { removeNullishFieldsParams } from "../shared/object_helpers";

@Component({
  selector: "app-cash-flow-report",
  templateUrl: "./cash-flow-report.component.html",
  styleUrls: ["./cash-flow-report.component.css"],
})
export class CashFlowReportComponent implements OnInit {
  isLoading = false;

  view = "monthly_payments_analysis";
  page = 1;
  paginate;

  views_conf = {
    filters: false,
    charts: false,
  };

  reports: any = {
    monthly_payments_analysis: {},
    monthly_payments_analysis_total: null,
    partner_monthly_payments_analysis: {},
    partner_monthly_payments_analysis_total: null,
  };

  charts: any = {
    projects_sales: {},
    matching: {},
    post_date_analysis: {
      months: {},
      years: {},
    },
  };

  chartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      gridLines: {
        display: false,
      },
    },

    layout: {
      padding: 10,
    },
    elements: {
      line: {
        fill: "origin",
        radius: 5,
        tension: 0.4,
      },
    },
  };

  filter_form: any = {};
  filter_schema: any = {};

  filter_dependencies = {
    projects: [],
    unitTypes: [],
    banks: [],
    years: Array(50)
      .fill("")
      .map((v, idx) => new Date().getUTCFullYear() - idx + 25),
    deal_statuses: ["all", "contracted", "pending"],
    project_types: ["Residential", "Commercial"],
    payment_types: ["fully-collected", "pending"],
  };
  downloading_export: any = false;
  monthsArray = Array.from({ length: 13 }, (_, i) => i);

  constructor(
    private slimLoadingBarService: SlimLoadingBarService,
    private financialReportsService: FinancialReportsService,
    private projectService: ProjectsService,
    private userService: UserServiceService,
    private errorHandlerService: ErrorHandlerService
  ) {}

  ngOnInit() {
    this.setView(this.view);
    this.getProjects({ only_has_partner: true });
  }

  getProjects(params: any = {}) {
    this.projectService.getProjectsPartners(params).subscribe((data: any) => {
      this.filter_dependencies.projects = data;
    });
  }

  setView(tab: string) {
    this.view = tab;
    this.filter_form = {};
    this.views_conf.filters = false;
    this.views_conf.charts = null;
    switch (tab) {
      case "monthly_payments_analysis": {
        this.filter_schema = {
          filter_project_id: 1,
          filter_date_from: 1,
          filter_date_to: 1,
        };
        this.getProjects({ only_has_partner: true });
        break;
      }
      case "partner_monthly_payments_analysis": {
        this.filter_schema = {
          filter_project_id: 1,
          filter_date_from: 1,
          filter_date_to: 1,
        };
        this.getProjects();
        break;
      }
    }

    this.getData();
  }

  getData() {
    this.page = 1;
    switch (this.view) {
      case "monthly_payments_analysis": {
        this.getMonthlyPaymentsReport();
        break;
      }
      case "partner_monthly_payments_analysis": {
        this.getPartnerMonthlyPaymentsReport();
        break;
      }
    }
  }

  getMonthlyPaymentsReport(is_export?) {
    if (is_export) {
      this.downloading_export = 1;
      this.filter_form.is_export = 1;
    } else {
      this.enableLoading();
    }
    this.financialReportsService
      .getMonthlyPaymentsReport(this.filter_form)
      .subscribe(
        (res: any) => {
          if (is_export) {
            window.open(res.url);
            this.downloading_export = false;
            this.filter_form.is_export = false;
            delete this.filter_form.type;
          } else {
            this.reports.monthly_payments_analysis_total = res.total_for_total;
            res = Object.entries(res).map(([key, value]) => {
              if (key == "total_for_total") return;
              let data = [];
              Object.entries(value).map(([key2, value2]) => {
                data.push({ value: value2 });
              });
              return {
                year: key,
                data: data,
              };
            });
            this.reports.monthly_payments_analysis = res;
            this.reports.monthly_payments_analysis = removeNullishFieldsParams(
              this.reports.monthly_payments_analysis
            );
            console.log(this.reports.monthly_payments_analysis);
            console.log(this.monthsArray);
          }
        },
        (err) => {
          this.downloading_export = false;
          console.log(err);
        },
        () => {
          if (this.view === "monthly_payments_analysis") {
            this.disableLoading();
          }
        }
      );
  }
  getPartnerMonthlyPaymentsReport(is_export?) {
    if (is_export) {
      this.downloading_export = 1;
      this.filter_form.is_export = 1;
    } else {
      this.enableLoading();
    }
    this.financialReportsService
      .getPartnerMonthlyPaymentsReport(this.filter_form)
      .subscribe(
        (res: any) => {
          if (is_export) {
            window.open(res.url);
            this.downloading_export = false;
            this.filter_form.is_export = false;
            delete this.filter_form.type;
          } else {
            this.reports.partner_monthly_payments_analysis_total =
              res.total_for_total;
            res = Object.entries(res).map(([key, value]) => {
              if (key == "total_for_total") return;
              let data = [];
              Object.entries(value).map(([key2, value2]) => {
                data.push({ value: value2 });
              });
              return {
                year: key,
                data: data,
              };
            });
            this.reports.partner_monthly_payments_analysis = res;
            console.log(this.reports.partner_monthly_payments_analysis);
            console.log(this.monthsArray);
          }
        },
        (err) => {
          this.downloading_export = false;
          console.log(err);
        },
        () => {
          if (this.view === "partner_monthly_payments_analysis") {
            this.disableLoading();
          }
        }
      );
  }

  // loading alg
  loading_texts = [
    "Initiating Report",
    "Calculate Data",
    "Grouping Results",
    "Loading",
  ];

  loader = {
    index: 0,
    dot: 0,
    maxDot: 3,
    text: this.loading_texts[0],
    interval: null,
  };
  enableLoading() {
    this.isLoading = true;

    this.loader.index = 0;
    this.loader.dot = 0;
    this.loader.text = this.loading_texts[0];

    this.loader.interval = setInterval(() => {
      if (!this.isLoading) return this.disableLoading();

      if (this.loader.dot < this.loader.maxDot) {
        this.loader.dot++;
        this.loader.text += ".";
      } else {
        this.loader.dot = 0;
        if (this.loader.index < this.loading_texts.length - 1) {
          this.loader.index++;
        } else {
          this.loader.index = 0;
        }
        this.loader.text = this.loading_texts[this.loader.index];
      }
    }, 1000);
  }

  disableLoading() {
    this.isLoading = false;
    clearInterval(this.loader.interval);
  }

  downloadReport(sub_type?) {
    switch (this.view) {
      case "monthly_payments_analysis": {
        this.getMonthlyPaymentsReport(1);
        break;
      }
      case "partner_monthly_payments_analysis": {
        this.getPartnerMonthlyPaymentsReport(1);
        break;
      }
    }
  }

  singleReportDownloadCombinedStatemenet(row) {
    console.log(row);
    this.financialReportsService
      .downloadReportCombinedStatementAccount(row.id)
      .subscribe((res: any) => {
        window.open(res);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/cash-flow-report/cash-flow-report.component.ts